// extracted by mini-css-extract-plugin
export default {"item":"SignCard_item__OdIDU","card":"SignCard_card__QWCf1"};